import {
  Wrench, Zap, GraduationCap, Sparkles, Hammer, Car, Snowflake, PaintRoller, Scissors, Stethoscope,
  Store, Smartphone, WashingMachine, Camera, Utensils, Truck, Briefcase, Gem, ShoppingBasket, Coffee,
  Croissant, Candy, UtensilsCrossed, Soup, Pizza, PartyPopper, Layers, Shirt, Footprints, Tv, TabletSmartphone,
  Laptop, Sofa, Drill, Pill, Glasses, BookOpen, Gift, Milk, Carrot, Drumstick, Flower2, Tractor, Cog, Bike,
  Dumbbell, Hotel, Building2, Plane, BookOpenCheck, TestTube, PawPrint, Printer, Music, Scale, SprayCan,
  Droplets, Cctv, Sun, CarTaxiFront, School, BrickWall, Flame,
} from "lucide-react";

export const ICONS = {
  wrench: Wrench, zap: Zap, "graduation-cap": GraduationCap, sparkles: Sparkles, hammer: Hammer, car: Car,
  snowflake: Snowflake, "paint-roller": PaintRoller, scissors: Scissors, stethoscope: Stethoscope, store: Store,
  smartphone: Smartphone, "washing-machine": WashingMachine, camera: Camera, utensils: Utensils, truck: Truck,
  briefcase: Briefcase, gem: Gem, "shopping-basket": ShoppingBasket, coffee: Coffee, croissant: Croissant,
  candy: Candy, "utensils-crossed": UtensilsCrossed, soup: Soup, pizza: Pizza, "party-popper": PartyPopper,
  layers: Layers, shirt: Shirt, footprints: Footprints, tv: Tv, "tablet-smartphone": TabletSmartphone,
  laptop: Laptop, sofa: Sofa, drill: Drill, pill: Pill, glasses: Glasses, "book-open": BookOpen, gift: Gift,
  milk: Milk, carrot: Carrot, drumstick: Drumstick, "flower-2": Flower2, tractor: Tractor, cog: Cog, bike: Bike,
  dumbbell: Dumbbell, hotel: Hotel, "building-2": Building2, plane: Plane, "book-open-check": BookOpenCheck,
  "test-tube": TestTube, "paw-print": PawPrint, printer: Printer, music: Music, scale: Scale,
  "spray-can": SprayCan, droplets: Droplets, cctv: Cctv, sun: Sun, "car-taxi-front": CarTaxiFront,
  school: School, "brick-wall": BrickWall, flame: Flame,
};

export const CategoryIcon = ({ name, className }) => {
  const C = ICONS[name] || Store;
  return <C className={className} strokeWidth={1.8} />;
};
